import { useContext } from 'react';

import { RecoveryAction } from '../../utils/errorHandler';

import { ToastContext, ToastContextType } from './ToastManager';

// Hook to access toast context
export const useToast = (): ToastContextType => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

// Hook for error-specific toast notifications
export const useErrorToast = () => {
  const { showError, showWarning } = useToast();

  const showAuthError = (
    message: string,
    recoveryActions?: RecoveryAction[]
  ) => {
    return showError(
      message,
      'Authentication Error',
      recoveryActions || [
        {
          label: 'Sign In Again',
          action: () => {
            window.location.href = '/auth';
          },
          primary: true,
        },
      ],
      true // Persistent for auth errors
    );
  };

  const showGoalError = (message: string, onRetry?: () => void) => {
    return showError(message, 'Goal Creation Failed', [
      {
        label: 'Try Again',
        action: onRetry || (() => window.location.reload()),
        primary: true,
      },
      {
        label: 'Skip for Now',
        action: () => {
          window.location.href = '/dashboard';
        },
      },
    ]);
  };

  const showStateError = (
    stateType: 'onboarding' | 'goals' | 'profile',
    message: string
  ) => {
    return showWarning(
      message,
      `${stateType.charAt(0).toUpperCase() + stateType.slice(1)} Issue`
    );
  };

  return {
    showAuthError,
    showGoalError,
    showStateError,
  };
};
